export default "__VITE_ASSET__o8lLcbxI__"